<script>
import AddAuditor from "@/components/modules/ia/auditor/AddAuditor.vue";
import {mapActions, mapGetters} from "vuex";
import {vueAppMixin} from "@/mixins/vueAppMixin";
import {PaginationMixin} from "@/mixins/PaginationMixin";
import AuditorMixin from "@/mixins/AuditorMixin";
import loading from "@/components/elements/AppLoading.vue";
import {AlertService} from "@/services/AlertService";

export default {
  name: "AuditorDPList",
  components: {loading, AddAuditor},
  mixins: [PaginationMixin, vueAppMixin, AuditorMixin],
  data() {
    return {
      filters: {
        page: 1,
        count: 30,
        query : '',
        status: 1,
        is_designated_person: 1,
        category:'latest_audit.auditorable.audit_date_end.date-picker',
        order_position:'desc'
      },
      loading : false,
      showCertificateModal: false,
      selectedCertificates: [],
      selectedPdf: null,
      selectedCertificateId: null,
      selectedCertificate: null,
      showUploadModal: false,
      uploadCertificates: [],
      selectedAuditor: null,
    }
  },
  methods: {
    ...mapActions(['deleteAuditor', 'getAuditorList','getSortedAuditorList', 'updateAuditor']),
    async showAuditor (auditorId) {
      await this.$router.push(
        {
          name: 'AuditorGeneralInfo',
          params: {
            id: auditorId,
          },
        },

      ).catch(() => {})
    },
    // async showAuditorDesignatedPersonCertificateInfo (auditorId, isDP) {
    //   await this.$router.push(
    //     {
    //       name: 'AuditorDesignatedPersonCertificateInfo',
    //       params: {
    //         id: auditorId,
    //         isDP: isDP
    //       },
    //     },
    //
    //   ).catch(() => {})
    // },
    async showAuditorDesignatedPersonCertificateInfo(auditorId, isDP) {
      const route = this.$router.resolve(
        {
          name: 'AuditorDesignatedPersonCertificateInfo',
          params: {
            id: auditorId,
            isDP: isDP
          },
        },
      )
      window.open(route.href,'_blank')
    },
    removeCertificate(index) {
      this.uploadCertificates.splice(index, 1);
    },
    async uploadCertificatesToAuditor(){

      if(!this.selectedAuditor){
        return;
      }

      let formData = new FormData();

      const newCertificates =
        this.uploadCertificates.filter(cert => cert.file);

      formData.append('from_dp_certificate', 1);

      newCertificates.forEach((cert,index)=>{

        formData.append(
          `certificate_files[${index}]`,
          cert.file
        );

        formData.append(
          `certificate_issued_dates[${index}]`,
          cert.issued_date || ''
        );

        formData.append(
          `certificate_expiration_dates[${index}]`,
          cert.expiration_date || ''
        );

        formData.append(
          `certificate_is_designated_person_certificate[${index}]`,
          1
        );
      });

      let response = await this.updateAuditor({

        id:this.selectedAuditor.id,

        formData:formData

      });

      if(response){
        await this.successAlert(
          'CERTIFICATES UPLOADED SUCCESSFULLY',
          'UPLOAD CERTIFICATE'
        );
        this.closeUploadModal();
        await this.filterAuditorList();
      }
    },
    openUploadModal(auditor) {
      this.selectedAuditor = auditor;
      this.uploadCertificates = [];
      this.showUploadModal = true;
    },

    closeUploadModal() {
      this.showUploadModal = false;
      this.uploadCertificates = [];
      this.selectedAuditor = null;
    },
    setCertificates(event) {

      const files = event.target.files;


      for(let i = 0; i < files.length; i++){

        this.uploadCertificates.push({

          file: files[i],

          file_name: files[i].name,

          issued_date: null,

          expiration_date: null,

          is_designated_person_certificate: 1

        });

      }


      event.target.value = null;
    },
    triggerFileUpload() {
      this.$refs.certificateUpload.click();
    },
    async downloadCertificate(certificate) {
      try {
        const response = await fetch(certificate.path_url);

        const blob = await response.blob();

        const blobUrl = window.URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = certificate.file_name;

        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);

      } catch (error) {
        console.error('Failed to download certificate:', error);
      }
    },
    selectCertificate(certificate) {
      this.selectedCertificateId = certificate.id
      this.selectedCertificate = certificate;
      this.viewCertificate(certificate.path_url)
    },
    showCertificates(certificates) {
      this.selectedCertificates = certificates.filter(
        cert => cert.is_designated_person_certificate === 1
      );

      this.selectedCertificateId = null;
      this.selectedPdf = null;

      if (this.selectedCertificates.length > 0) {
        this.showCertificateModal = true;
      }
    },
    closeCertificateModal() {
      this.showCertificateModal = false;
      this.selectedCertificates = [];
      this.selectedPdf = null;
      this.selectedCertificateId = null;
      this.selectedCertificate = null;
    },
    viewCertificate(url) {
      this.selectedPdf = url;
    },
    async deleteSelected(auditorId) {
      if(await AlertService.confirmDeleteAlert('Delete Auditor', 'Are you sure you want to delete this Auditor?', 'Delete')){
        swal.fire({
          title:'ENTER YOUR PASSWORD',
          input: 'password',
          inputAttributes: {
            autocapitalize: 'off'
          },
          confirmButtonText:'PROCEED DELETION',
          cancelButtonText: 'CANCEL',
          showCancelButton:true,
          allowOutsideClick:false,
          allowEscapeKey:false,
          allowEnterKey:false,
          confirmButtonColor:'#dc3545',
          showLoaderOnConfirm:true,
          preConfirm:async (inputValue)=> {
            let response = await this.deleteAuditor({auditor_id: auditorId, password: inputValue});
            if (typeof response === 'boolean' && response) {
              return response;
            } else {
              if (response.hasOwnProperty('message') && !response.hasOwnProperty('errors')) {
                swal.showValidationMessage(response.message);
              }
              else{
                swal.showValidationMessage(response.errors.password.join(','));
              }
            }
          }
        })
          .then(async (result)=>{
            if(result.isConfirmed){
              await this.successAlert('AUDITOR DELETED SUCCESSFULLY','DELETE AUDITOR');
              await this.filterAuditorList();
            }
          });
      }

    },
    async setPage(page) {
      this.pagination.currentPage = page;
      this.filters.page = page
      await this.filterAuditorList();
    },
    async filterAuditorList() {
      this.loading = true;
      await this.getSortedAuditorList(this.filters);
      this.loading = false;
    },
  },
  async created() {
    this.getNewAuditorsList = _.debounce(this.filterAuditorList, 500);
    await this.filterAuditorList();
  },
  watch: {
    async 'filters.count'(count) {
      this.filters.count = count
      this.filters.page = 1
      await this.filterAuditorList();
    },
    async 'filters.status'(status) {
      this.filters.status = status;
      this.filters.page = 1;
      await this.filterAuditorList();
    },
    async 'filters.is_designated_person'(is_designated_person) {
      this.filters.is_designated_person = is_designated_person;
      this.filters.page = 1;
      await this.filterAuditorList();
    },
    async 'filters.query'(query) {
      this.filters.query = query;
      this.filters.page = 1;
      await this.getNewAuditorsList();
    },
    async 'filters.category'(category){
      this.filters.category = category;
      this.filters.page = 1;
      await this.filterAuditorList();
    },
    async 'filters.order_position'(position){
      this.filters.order_position = position;
      this.filters.page = 1;
      await this.filterAuditorList();
    }
  },
  computed : {
    ...mapGetters([
      'auditorList'
    ]),
  }
}
</script>

<template>
  <div class="container-fluid px-4">
    <div class="row">
      <div class="col-12 pl-0">
        <div>
          <div class="row no-gutters justify-content-between mb-1">
            <div class="col-sm-auto flex-grow-0">
              <h3 class="mb-0 text-left">List of DP Certificates</h3>
            </div>
          </div>
          <div class="row no-gutters align-items-center justify-content-between">
            <div class="col-sm-auto pb-2 mr-2">
              <nav aria-label="...">
                <ul class="pagination text-smallest mb-0 pb-0">
                  <li class="page-item" :class="{ 'disabled': pagination.currentPage === 1}">
                    <button class="page-link" @click="setPage(1)">First</button>
                  </li>

                  <li v-for="page in paginationPages" :key="page" class="page-item" :class="{ 'disabled': page === '...', 'active': page === pagination.currentPage }">
                    <button class="page-link" @click="setPage(page)">{{ page }}</button>
                  </li>

                  <li class="page-item" :class="{ 'disabled': pagination.currentPage === pagination.lastPage}">
                    <button class="page-link" @click="setPage(pagination.lastPage)">Last</button>
                  </li>
                </ul>
              </nav>
            </div>
            <div class="col-5 pb-2">
              <div class="d-flex align-items-end justify-content-end filter-container">
                <div class="filter-item search-item">
                  <label class="filter-label">&nbsp;</label>
                  <form id="search-form" @submit.prevent>
                    <input
                      type="text"
                      id="auditorSearch"
                      class="form-control form-control-sm"
                      v-model="filters.query"
                      placeholder="Search Auditor"
                    >
                  </form>
                </div>
                <div class="filter-item">
                  <label class="filter-label">Status</label>
                  <select
                    class="form-control form-control-sm"
                    v-model="filters.status"
                  >
<!--                    <option :value="null">All</option>-->
                    <option value="1">Active</option>
                    <option value="0">Inactive</option>
                  </select>
                </div>
                <div class="filter-item show-item">
                  <label class="filter-label">Show</label>
                  <select
                    id="rowCount"
                    class="form-control form-control-sm"
                    v-model="filters.count"
                  >
                    <option value="30">30 Rows</option>
                    <option value="50">50 Rows</option>
                    <option value="100">100 Rows</option>
                    <option value="10000">All Rows</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="row no-gutters justify-content-between mb-1">
            <div class="col-sm-12">
              <div v-if="loading">
                <loading></loading>
              </div>
              <table v-else class="small e-tbl text-center">
                <thead class="bg-white" style="position: sticky; top: 0; z-index: 2">
                <tr>
                  <th class="align-middle" rowspan="2" style="width: 2em" scope="col">#</th>
                  <th class="align-middle" rowspan="2" scope="col">NAME</th>
                  <th class="align-middle" rowspan="2" scope="col">BRANCH DP</th>
                  <th class="align-middle" rowspan="2" scope="col">CERTIFICATES</th>
                  <th class="align-middle" rowspan="2" scope="col">ACTION</th>
                  <th class="align-middle" rowspan="2" style="width: 10em" scope="col">STATUS</th>
                </tr>
                </thead>
                <tbody>
                <template v-if="auditorList.length > 0">
                  <tr v-for="(auditor, index) in auditorList" :key="auditor.id" class="ia-auditor-list no-select" @dblclick="showAuditorDesignatedPersonCertificateInfo(auditor.id, true)">
                    <td>{{ pagination.from + index}}</td>
                    <td>{{ auditor?.name?.toUpperCase() }}</td>
                    <td>{{ auditor?.dp_branch_office?.name.toUpperCase() }}</td>
                    <td
                      style="cursor: pointer"
                      @click="showCertificates(auditor?.certificates || [])"
                    >
                    <span
                      class="text-primary font-weight-bold"
                      v-if="auditor?.certificates?.filter(cert => cert.is_designated_person_certificate === 1).length"
                    >
                      {{ auditor.certificates.filter(cert => cert.is_designated_person_certificate === 1).length }}
                    </span>
                      <span v-else>
                      0
                    </span>
                    </td>
                    <td>
                      <button
                        class="btn btn-secondary btn-sm px-3"
                        @click="openUploadModal(auditor)"
                      >
                        Upload Certificate
                      </button>
                    </td>
                    <td
                      :class="{
                    'td-status-active': auditor?.is_active === 1,
                    'td-status-inactive': auditor?.is_active === 0
                  }"
                    >
                      <span class="text-white">
                        {{ auditor?.is_active === 1 ? 'ACTIVE' : 'INACTIVE' }}
                      </span>
                    </td>
                  </tr>
                </template>
                <template v-else>
                  <tr>
                    <td colspan="6" class="text-center font-weight-bold p-4">
                      No data found
                    </td>
                  </tr>
                </template>
                </tbody>
              </table>
            </div>
          </div>
          <AddAuditor
          />

          <!-- Designated Person Certificates Modal List Start -->
          <div v-if="showCertificateModal" class="certificate-modal-overlay">

            <div class="certificate-modal">

              <div class="certificate-modal-header">

                <h5>
                  DP Certificates
                </h5>

                <button
                  class="btn btn-danger btn-sm"
                  @click="closeCertificateModal"
                >
                  X
                </button>

              </div>

              <div class="certificate-modal-body">

                <div class="certificate-list">

                  <div
                    v-for="certificate in selectedCertificates"
                    :key="certificate.id"
                    class="border p-2 mb-3 certificate-card"
                    :class="{ 'selected-certificate': selectedCertificateId === certificate.id }"
                    @click="selectCertificate(certificate)"
                  >
                    <div class="d-flex align-items-start">
                      <font-awesome-icon
                        icon="file-pdf"
                        size="2x"
                        class="force-danger-all mr-2 flex-shrink-0"
                      />
                      <strong
                        class="certificate-filename"
                        :title="certificate.file_name"
                      >
                        {{ certificate.file_name }}
                      </strong>
                    </div>

                    <br>

                    Issued:
                    {{ certificate.issued_date ?? 'N/A' }}

                    <br>

                    Expiry:
                    {{ certificate.expiration_date ?? 'N/A' }}

                  </div>

                  <button
                    v-if="selectedCertificate"
                    class="btn btn-primary btn-sm mb-2"
                    @click="downloadCertificate(selectedCertificate)"
                  >
                    Download PDF
                  </button>

                </div>

                <div class="pdf-viewer">

                  <iframe
                    v-if="selectedPdf"
                    :src="selectedPdf + '#toolbar=0'"
                    frameborder="0"
                  ></iframe>

                  <div
                    v-else
                    class="text-center text-muted mt-5"
                  >
                    Select a certificate to preview PDF
                  </div>
                </div>
              </div>
            </div>

          </div>
          <!-- Designated Person Certificates Modal ListEnd -->

          <!-- Upload Certificate Modal Start -->
          <div v-if="showUploadModal" class="certificate-modal-overlay">

            <div class="certificate-modal upload-modal">

              <div class="certificate-modal-header">

                <h5>
                  Upload DP Certificate
                </h5>

                <button
                  class="btn btn-danger btn-sm"
                  @click="closeUploadModal"
                >
                  X
                </button>

              </div>

              <div class="upload-modal-body">

                <div class="attachment-container">

                  <button
                    class="btn btn-success mb-3"
                    @click="triggerFileUpload"
                  >
                    <font-awesome-icon icon="paperclip"/>
                    Add Attachments
                  </button>

                  <div
                    v-if="uploadCertificates.length"
                    class="text-muted mb-3"
                  >
                    {{ uploadCertificates.length }}
                    {{ uploadCertificates.length === 1 ? 'file' : 'files' }}
                    selected
                  </div>

                  <input
                    type="file"
                    multiple
                    class="d-none"
                    ref="certificateUpload"
                    accept="application/pdf"
                    @change="setCertificates"
                  />

                  <div
                    v-if="uploadCertificates.length"
                    class="attachment-list"
                  >

                    <div
                      v-for="(certificate,index) in uploadCertificates"
                      :key="index"
                      class="border p-2 mb-2 certificate-card position-relative"
                    >

                      <button
                        type="button"
                        class="btn btn-sm btn-danger attachment-remove-btn"
                        @click="removeCertificate(index)"
                      >
                        ×
                      </button>

                      <div class="d-flex align-items-center">

                        <font-awesome-icon
                          icon="file-pdf"
                          size="2x"
                          class="force-danger-all mr-2"
                        />

                        <strong>
                          {{ certificate.file_name }}
                        </strong>

                      </div>

                      <div class="form-group mt-2">

                        <label>
                          Issued Date
                        </label>

                        <input
                          type="date"
                          class="form-control form-control-sm"
                          v-model="certificate.issued_date"
                        />

                      </div>


                      <div class="form-group">

                        <label>
                          Expiry Date
                        </label>

                        <input
                          type="date"
                          class="form-control form-control-sm"
                          v-model="certificate.expiration_date"
                        />

                      </div>

                    </div>

                  </div>

                  <div
                    v-else
                    class="text-center text-muted mt-4"
                  >
                    No attachments selected yet
                  </div>

                </div>

                <div v-if="uploadCertificates.length > 0" class="modal-footer">
                  <button
                    class="btn btn-primary"
                    @click="uploadCertificatesToAuditor"
                  >
                    Save
                  </button>
                </div>

              </div>

            </div>

          </div>
          <!-- Upload Certificate Modal End -->

        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.e-tbl {
  table-layout: fixed;
}
.e-tbl thead tr th {
  border: 1px solid #b1b1b1;
}

.date-highlight {
  font-weight: bold;
  color: #007bff;
}
.td-status-active {
  background-color: #3abd82;
}

.td-status-inactive {
  background-color: #6b757d;
}

.certificate-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;

  width: 100vw;
  height: 100vh;

  background: rgba(0, 0, 0, 0.5);

  display: flex;
  justify-content: center;
  align-items: center;

  z-index: 999999;
}

.certificate-modal {
  background: white;

  width: 90vw;
  height: 85vh;

  border-radius: 8px;

  box-shadow: 0 5px 20px rgba(0,0,0,0.3);

  display: flex;
  flex-direction: column;

  overflow: hidden;
}

.certificate-modal-header {

  height: 60px;

  padding: 15px 20px;

  display: flex;
  justify-content: space-between;
  align-items: center;

  border-bottom: 1px solid #ddd;

  background: white;

  position: sticky;
  top: 0;

  z-index: 10;

}

.certificate-modal-body {

  flex: 1;

  display: flex;

  overflow: hidden;

}

.certificate-list {

  width: 35%;

  padding: 15px;

  overflow-y: auto;

  border-right: 1px solid #ddd;

}

.pdf-viewer {

  width: 65%;

  height: 100%;

}


.pdf-viewer iframe {

  width: 100%;

  height: 100%;

}

.certificate-card {
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  position: relative;
}

.attachment-remove-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 24px;
  height: 24px;
  padding: 0;
  line-height: 1;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.certificate-card:hover {
  background-color: #f8f9fa;
  border-color: #dc3545 !important;
  box-shadow: 0 0 8px rgba(220, 53, 69, 0.3);
}

.selected-certificate {
  background-color: #fff3cd !important;
  border-color: #ffc107 !important;
  box-shadow: 0 0 8px rgba(255, 193, 7, 0.5);
}

.certificate-filename {
  word-break: break-word;
  overflow-wrap: anywhere;
  white-space: normal;
}

.upload-modal {
  width: 50vw;
  height: 70vh;
}


.upload-modal-body {
  flex: 1;
  padding: 20px;
  overflow-y: auto;
}


.attachment-container {
  width: 100%;
}


.attachment-list {
  max-height: 45vh;
  overflow-y: auto;
}

.e-tbl tbody tr {
  height: 50px;
}

.e-tbl td {
  vertical-align: middle !important;
}

.e-tbl td button {
  margin: 5px 0;
}
.filter-container {
  gap: 8px;
}

.filter-container input {
  width: 150px;
}

.filter-container select {
  width: auto;
  min-width: 130px;
}

#rowCount {
  min-width: 70px;
}
</style>
